// extracted by mini-css-extract-plugin
export default {"l_Media_main":"Media_l_Media_main__MdDQu"};